import { addDays, endOfDay, isSameDay, parseISO, startOfDay } from 'date-fns';

import type { CalendarEvent } from '@/types/calendarTypes';

function allDayInclusiveEnd(event: CalendarEvent, start: Date): Date {
  if (!event.end) return endOfDay(start);

  const end = parseISO(event.end);
  if (Number.isNaN(end.getTime())) return endOfDay(start);

  const startDay = startOfDay(start);
  const endDay = startOfDay(end);

  if (endDay > startDay) {
    return endOfDay(addDays(endDay, -1));
  }

  return endOfDay(startDay);
}

export function eventOccursOnCalendarDay(event: CalendarEvent, day: Date): boolean {
  const start = parseISO(event.start);
  if (Number.isNaN(start.getTime())) return false;

  const dayStart = startOfDay(day);
  const dayEnd = endOfDay(day);
  const end = event.allDay ? allDayInclusiveEnd(event, start) : event.end ? parseISO(event.end) : start;

  if (Number.isNaN(end.getTime())) return isSameDay(start, day);

  return start <= dayEnd && end >= dayStart;
}
